import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

type CountryState = {
  selectedCountry: string;
  countryName: string;
  wsId: number;
  countryCode: string;
};

const getInitialCountry = (): string => {
  return localStorage.getItem('selectedCountry') || 'india';
};

const initialCountry = getInitialCountry();

const initialState: CountryState = {
  selectedCountry: initialCountry,
  countryName: initialCountry === 'india' ? 'India' : 'Thailand',
  wsId: initialCountry === 'india' ? 1 : 2,
  countryCode: initialCountry === 'india' ? 'IN' : 'TH',
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setSelectedCountry: (
      state,
      action: PayloadAction<string>
    ) => {
      state.selectedCountry = action.payload;
      state.countryName =
        action.payload === 'india' ? 'India' : 'Thailand';
      state.wsId = action.payload === 'india' ? 1 : 2;
      state.countryCode =
        action.payload === 'india' ? 'IN' : 'TH';
      localStorage.setItem('selectedCountry', action.payload);
    },
  },
});

export const { setSelectedCountry } = countrySlice.actions;
export default countrySlice.reducer;
